module.exports = __webpack_public_path__ + "static/media/BIOS.ec108db9.jpg";